import React from 'react';
import { Accordion, Box, Copy, Link, Optional, useAccordion } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import Error from '../PriceComponent/Error';
import Loader from '../../utils/components/Loader';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import themeStyles from './CustomizationSummary.styles';
import { gtmEditBuild, gtmExpandAccordionItem } from './utils/handleGtmEvents';
const Container = themeStyles.apply(Box, 'Container');
const Header = themeStyles.apply(Box, 'Header');
const Section = themeStyles.apply(Box, 'Section');
const handleEditBuildClick = ({ linkUrl, gtmPayload }) => {
    gtmEditBuild({
        linkText: 'edit build',
        linkUrl,
        componentType: gtmPayload.componentType,
        model: gtmPayload.model,
        trim: gtmPayload.trim,
        gtmBodyStyle: gtmPayload.bodyStyle,
        inventoryStatus: gtmPayload.inventoryStatus,
    });
};
const handleExpandAccordionItem = ({ gtmPayload, key }) => {
    gtmExpandAccordionItem({
        linkText: `expand: ${key}`,
        componentType: gtmPayload.componentType,
        model: gtmPayload.model,
        trim: gtmPayload.trim,
        gtmBodyStyle: gtmPayload.bodyStyle,
        inventoryStatus: gtmPayload.inventoryStatus,
    });
};
const CustomizationSummary = ({ sections, title, editBuildCtaText, editBuildCtaHref, editBuildCtaQueryString, showLoader, showError, gtmPayload, }) => {
    const { t } = useTranslation();
    const linkUrl = `${editBuildCtaHref}?${editBuildCtaQueryString}`;
    const accordionBehaviour = useAccordion(sections);
    const behaviour = {
        ...accordionBehaviour,
        toggleItem: (key) => {
            accordionBehaviour.toggleItem(key);
            if (!accordionBehaviour.isActive(key)) {
                handleExpandAccordionItem({ gtmPayload, key });
            }
        },
    };
    return (React.createElement(Container, { my: "l", "data-testid": "cy-customization-summary" },
        React.createElement(Header, null,
            React.createElement(Section, null,
                React.createElement(Copy, { "data-testid": "cy-customization-summary-title", as: "h5", fontFamily: "bold", letterSpacing: "small", size: "subheading" }, title)),
            React.createElement(Section, null,
                React.createElement(Link, { href: true, as: RoutableSitecoreLink, field: {
                        value: {
                            href: editBuildCtaHref,
                            querystring: editBuildCtaQueryString,
                            linktype: 'internal',
                            // TODO: is hard coded okay?
                            anchor: 'exterior',
                        },
                    }, styling: "tertiary2", size: "regular", ml: "s", onClick: () => handleEditBuildClick({ linkUrl, gtmPayload }), "data-testid": "cy-customization-summary-edit-build" }, editBuildCtaText))),
        React.createElement(Optional, { when: showLoader },
            React.createElement(Loader, { testId: "cy-customization-summary-content-loading-state" })),
        React.createElement(Optional, { when: showError },
            React.createElement(Error, { message: t('Pages.Bap.apiLoadingError'), verticalAlignment: "center", errorIconName: "exclamationAlert" })),
        React.createElement(Optional, { when: !showLoader && !showError },
            React.createElement(Accordion, { isCompact: true, hasBottomBorder: false, itemsHaveTopBorder: false, activeTitleHasBorder: false, contentContainerStyles: { py: 'xs' }, items: sections, behaviour: behaviour, itemOnExpandEvent: (key) => handleExpandAccordionItem({ gtmPayload, key }) }))));
};
export default CustomizationSummary;
